import React, { useRef, type RefObject } from 'react';
import { useDarkSweep } from '../hooks/useDarkSweep';
interface DarkSweepProps {
  /** Element whose position triggers dark mode (the "Let's make them feel something" headline) */
  triggerRef: RefObject<HTMLElement>;
  /** Element whose bottom edge ends dark mode again (the project grid) */
  endRef?: RefObject<HTMLElement>;
  /** Element whose position turns the backdrop blue for the work (the statement before the projects) */
  accentTriggerRef?: RefObject<HTMLElement>;
}
const PANEL = 'pointer-events-none fixed inset-0 opacity-0 transition-opacity duration-700 ease-[cubic-bezier(0.65,0,0.35,1)] motion-reduce:transition-none';

/**
 * Full-screen backdrops: black fades in once the trigger reaches the middle of the screen, then blue
 * (#1A2FFB) fades in over it for the work. Rendered BEFORE the content sections so they paint on top of it
 * (they're `relative` with transparent backgrounds).
 */
export function DarkSweep({
  triggerRef,
  endRef,
  accentTriggerRef
}: DarkSweepProps) {
  const panelRef = useRef<HTMLDivElement>(null);
  const accentRef = useRef<HTMLDivElement>(null);
  useDarkSweep(triggerRef, panelRef, endRef, accentTriggerRef, accentRef);
  return <>
      <div ref={panelRef} aria-hidden="true" className={`${PANEL} bg-black`} data-id="element-46" data-mp="2mpsn23uar3tm" />
      <div ref={accentRef} aria-hidden="true" className={`${PANEL} bg-[#1A2FFB]`} data-id="element-47" data-mp="2roveuml9ndjn" />
    </>;
}